/* eslint-disable @typescript-eslint/naming-convention -- API types use snake_case */
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ISessionRequestStore {
  loadSessionRequestList: () => void;
  updateSelectedSession: (session: RequestSessionRequest) => void;
  getClientReferralMemberSessionRequest: (referralMemberId: number) => Observable<RequestSessionRequest>;
  submitSessionRequest: (
    sessionRequest: RequestSessionRequest,
    daysOfWeek: string[],
    personaProviderId: number
  ) => Observable<void>;
}

export interface IRequestSessionRequest {
  client_referral_member_id: number;
  days_of_week: string[];
  descriptive_text: string;
  request_type?: SessionTypes;
}

export const SESSION_REQUEST_STORE = new InjectionToken<ISessionRequestStore>('SessionRequest Store');

export class RequestSessionRequest implements IRequestSessionRequest {
  client_referral_member_id: number;
  days_of_week: string[];
  descriptive_text: string;
  request_type?: SessionTypes;

  constructor(response?: IRequestSessionRequest) {
    this.client_referral_member_id = response?.client_referral_member_id || 0;
    this.days_of_week = response?.days_of_week || [];
    this.descriptive_text = response?.descriptive_text || '';
    this.request_type = response?.request_type || null;
  }
}

export enum SessionTypes {
  FREE_CONSULTATION = 'free_consultation',
  SESSION = 'session'
}
